import { useSearchParams } from 'react-router-dom';
import { socialPostApi } from '../../api/socialPostApi';
import TargetComments from '../comments/TargetComments';
import { parseCommentContextQuery } from '../comments/commentContextNavigation';
import { SOCIAL_ACTION_PRODUCT_CHROME as chrome } from './socialActionPresentation';

export default function SocialPostComments({ postId, onCommentCreated, onCommentDeleted }) {
  const [params] = useSearchParams();
  const commentContext = parseCommentContextQuery(params.toString());
  return (
    <TargetComments
      targetId={postId}
      commentApi={socialPostApi}
      title={chrome.comments}
      emptyHint={chrome.noComments}
      composeLabel={chrome.addComment}
      commentContext={commentContext}
      onCommentCreated={onCommentCreated}
      onCommentDeleted={onCommentDeleted}
    />
  );
}
